import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select as BaseSelect,
  SelectChangeEvent,
} from "@mui/material";
import { ClassNameMap } from "@mui/material";

interface IOptions {
  text: string;
  name: string | number | boolean;
}
interface IProps {
  value: string | undefined;
  onChange: (event: SelectChangeEvent<string>, child: React.ReactNode) => void;
  options: IOptions[];
  inputLabel?: string;
  label?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  size?: "small" | "medium";
  name?: string;
  baseSelectStyles?: {
    className: string;
    classes?: Partial<ClassNameMap>;
  };
}
const Select: React.FC<IProps> = ({
  value,
  onChange,
  options,
  inputLabel,
  label,
  disabled,
  fullWidth,
  size = "medium",
  name,
  baseSelectStyles,
}) => {
  return (
    <FormControl
      fullWidth={fullWidth}
      variant="outlined"
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
      size={size}
    >
      <InputLabel>{inputLabel}</InputLabel>

      <BaseSelect
        name={name}
        disabled={disabled}
        fullWidth
        value={value}
        onChange={onChange}
        label={label}
        className={baseSelectStyles?.className}
        classes={baseSelectStyles?.classes}
      >
        {options.map(({ text, name, ...optionsProps }) => (
          // @ts-ignore
          <MenuItem value={name} key={name} {...optionsProps}>
            {text}
          </MenuItem>
        ))}
      </BaseSelect>
    </FormControl>
  );
};

export default Select;
